
window.addEventListener('load', function() {
	void window.Ucoast.mediaManager.initialLoad();
});
